import { QueryApiService } from 'src/common/api-service';
import { AuditableEntity } from '../common';
import { JobRole } from './job-roles-api';

export interface JobDomain extends AuditableEntity<string> {
  name: string;
  roles: JobRole[];
}

export class JobDomainApiService extends QueryApiService<JobDomain> {
  constructor() {
    super('jobDomains');
  }
}
